import { useRef, useEffect } from 'react';

export function useFinalCacheInvalidationOnStreamEnd(
  isStreaming: boolean,
  activeConversationId: string | undefined,
  invalidateConversationObjects: (conversationId: string) => void,
) {
  const prevIsStreamingRef = useRef(false);

  useEffect(() => {
    // Fire one final invalidation when streaming ends to flush any objects changed during the turn.
    // The polling effect only fires while isStreaming=true, so a quick agent turn (< 3 seconds)
    // cancels the initial timer before it fires — this catches that gap.
    if (prevIsStreamingRef.current && !isStreaming && activeConversationId) {
      invalidateConversationObjects(activeConversationId);
    }
    prevIsStreamingRef.current = isStreaming;
  }, [isStreaming, activeConversationId, invalidateConversationObjects]);
}
